import React, {useRef, useState} from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Col, Row} from "antd";

import {useSubCompanies} from "../../../hooks/useSubCompanies";
import {PoolForm} from "../components/poolForm/PoolForm";

const NewPool = ({}) => {
    const {t} = useTranslation(["pools"]);
    const mapRef = useRef(null);
    const {subCompanies, subCompanyLoading, loadSubCompanies} = useSubCompanies({});
    const [selectedSubCompanies, setSelectedSubCompanies] = React.useState([]);
    const handleSelectedSubCompaniesChange = selectedSubCompanyIds => {
        const selectedSubCompanies = subCompanies.filter(subCompany =>
            selectedSubCompanyIds.includes(subCompany._id.toString())
        );
        setSelectedSubCompanies(selectedSubCompanies);
    };

    return useObserver(() => (
        <Row type="flex" justify="center" data-testid="newPoolScreen" gutter={[0, 20]}>
            <Col span={20}>
                <h1>{t("screens.newPool", {ns: "pools"})}</h1>
                <PoolForm
                    subCompanyOptions={subCompanies}
                    subCompanyOptionsLoading={subCompanyLoading}
                    loadSubCompanies={loadSubCompanies}
                    onSelectedSubCompaniesChange={handleSelectedSubCompaniesChange}
                    mapRef={mapRef}
                />
            </Col>
        </Row>
    ));
};

export default NewPool;
